import { IconRotate2 } from '@tabler/icons-react';
import { useProposal } from '../../context/ProposalContext';
import { Button, Loader, Modal, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useDisclosure } from '@mantine/hooks';
import { useGeneration } from '@/hooks/useGeneration';

export default function RegenerateAssumptions() {
  const { proposal, dispatchProposal, userFeedback, dispatchUserFeedback, dispatchOtherData } =
    useProposal();
  const { loadingAssumptions } = userFeedback;
  const { t } = useTranslation();
  const [opened, { open, close }] = useDisclosure();

  const { withService, cancelField } = useGeneration({
    dispatchProposal,
    dispatchUserFeedback,
    dispatchOtherData,
  });

  const handleGenerateAssumptions = async () => {
    const config = {
      input: proposal.input,
      documentLanguage: proposal.language,
      proposal,
    };

    withService(async (svc) => {
      await svc.generateAssumptions(config, {
        dispatchProposal,
        dispatchUserFeedback,
        dispatchOtherData,
      });
    });
    close();
  };

  const handleCancel = () => {
    cancelField('assumptions');
  };

  return (
    <>
      <Button
        color={loadingAssumptions ? 'orange' : 'cyan'}
        variant="light"
        size="xs"
        leftSection={
          loadingAssumptions ? <Loader size="xs" color="cyan" /> : <IconRotate2 size={16} />
        }
        onClick={loadingAssumptions ? handleCancel : open}
      >
        {loadingAssumptions ? t('cancel') : t('regenerate')}
      </Button>

      <Modal opened={opened} onClose={close} title={t('confirmRegeneration')}>
        <div>{t('confirmRegenerateAssumptions')}</div>
        <Group justify="flex-end" mt="md">
          <Button color="gray" onClick={close}>
            {t('cancel')}
          </Button>
          <Button color="cyan" onClick={handleGenerateAssumptions}>
            {t('confirm')}
          </Button>
        </Group>
      </Modal>
    </>
  );
}
